/* HANIA STUDIO — premium interactions (gallery zoom, lightbox, circles, reels, sticky ATC) */
(function () {
  'use strict';
  var FINE = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var SAVE = !!(navigator.connection && navigator.connection.saveData);
  var ICON = {
    mute: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="m23 9-6 6M17 9l6 6"/></svg>',
    sound: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M19 5a10 10 0 0 1 0 14"/></svg>'
  };
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || document).querySelectorAll(s)); }
  function lockBody(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  /* ---------------- PRODUCT GALLERY ---------------- */
  function initGallery() {
    var g = $('.hs-gallery');
    if (!g || g.dataset.hsReady) return;
    g.dataset.hsReady = '1';
    var mainEl = $('.tf-product-media-main', g);
    var thumbsEl = $('.tf-product-media-thumbs');
    var slides = $$('.swiper-slide', mainEl);
    var sw = mainEl.swiper;
    if (!sw && window.Swiper) {
      var th = thumbsEl ? thumbsEl.swiper : null;
      if (thumbsEl && !th) {
        th = new Swiper(thumbsEl, {
          spaceBetween: parseInt(thumbsEl.dataset.space || 8, 10),
          slidesPerView: 5, watchSlidesProgress: true,
          breakpoints: {
            0: { direction: 'horizontal', slidesPerView: 5 },
            1200: { direction: thumbsEl.dataset.direction || 'vertical', slidesPerView: parseInt(thumbsEl.dataset.preview || 5, 10) }
          }
        });
      }
      sw = new Swiper(mainEl, { spaceBetween: 0, speed: 450, simulateTouch: !FINE, thumbs: th ? { swiper: th } : undefined });
    }
    if (sw && FINE) sw.allowTouchMove = false;

    var prev = $('.hs-nav.prev', g), next = $('.hs-nav.next', g), counter = $('.hs-counter', g);
    function upd() {
      var i = sw ? sw.activeIndex : 0;
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      if (prev) prev.classList.toggle('swiper-button-disabled', i === 0);
      if (next) next.classList.toggle('swiper-button-disabled', i >= slides.length - 1);
      $$('video', mainEl).forEach(function (v) { if (!v.closest('.swiper-slide-active')) v.pause(); });
    }
    if (sw) {
      sw.on('slideChange', upd); upd();
      if (prev) prev.addEventListener('click', function () { sw.slidePrev(); });
      if (next) next.addEventListener('click', function () { sw.slideNext(); });
    }

    /* in-place hover zoom (desktop) */
    if (FINE) {
      $$('.item[data-zoomable]', g).forEach(function (it) {
        var layer = $('.hs-zoom-layer', it), loaded = false;
        it.addEventListener('mouseenter', function () {
          if (!loaded) { layer.style.backgroundImage = 'url("' + it.dataset.zoomable + '")'; loaded = true; }
          it.classList.add('hs-zoom-on');
        });
        it.addEventListener('mousemove', function (e) {
          var r = it.getBoundingClientRect();
          var x = Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100));
          var y = Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100));
          layer.style.backgroundPosition = x.toFixed(2) + '% ' + y.toFixed(2) + '%';
        });
        it.addEventListener('mouseleave', function () { it.classList.remove('hs-zoom-on'); });
      });
    }

    /* lightbox */
    var imgs = $$('.item[data-zoomable]', g).map(function (a) { return { src: a.dataset.zoomable, idx: parseInt(a.dataset.index, 10) }; });
    var lb = null;
    function buildLB() {
      lb = document.createElement('div');
      lb.className = 'hs-lb';
      lb.setAttribute('role', 'dialog');
      lb.innerHTML = '<div class="hs-lb-top"><span class="hs-lb-count"></span><button class="hs-lb-close" aria-label="Close">&times;</button></div><div class="hs-lb-track"></div><div class="hs-lb-hint">TAP TO ZOOM · SWIPE FOR MORE</div>';
      var track = $('.hs-lb-track', lb);
      imgs.forEach(function (im) {
        var s = document.createElement('div');
        s.className = 'hs-lb-slide';
        s.innerHTML = '<img loading="lazy" alt="" src="' + im.src + '">';
        track.appendChild(s);
      });
      document.body.appendChild(lb);
      $('.hs-lb-close', lb).addEventListener('click', closeLB);
      track.addEventListener('click', function (e) {
        var img = e.target.closest('img'); if (!img) return;
        var s = img.parentNode, r = img.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        s.classList.toggle('zoomed');
        if (s.classList.contains('zoomed')) {
          requestAnimationFrame(function () {
            s.scrollLeft = px * img.offsetWidth - s.clientWidth / 2;
            s.scrollTop = py * img.offsetHeight - s.clientHeight / 2;
          });
        }
      });
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        $('.hs-lb-count', lb).textContent = (i + 1) + ' / ' + imgs.length;
      }, { passive: true });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('open')) closeLB(); });
    }
    function openLB(i) {
      if (!imgs.length) return;
      if (!lb) buildLB();
      var pos = 0;
      imgs.forEach(function (im, k) { if (im.idx === i) pos = k; });
      lb.classList.add('open'); lockBody(true);
      var track = $('.hs-lb-track', lb);
      $$('.hs-lb-slide', lb).forEach(function (s) { s.classList.remove('zoomed'); });
      track.scrollLeft = pos * track.clientWidth;
      $('.hs-lb-count', lb).textContent = (pos + 1) + ' / ' + imgs.length;
    }
    function closeLB() { lb.classList.remove('open'); lockBody(false); }
    $$('.hs-lb-open', g).forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openLB(parseInt(a.dataset.index, 10)); }, true);
    });
    var ex = $('.hs-expand', g);
    if (ex) ex.addEventListener('click', function () { openLB(sw ? sw.activeIndex : 0); });
  }

  /* ---------------- CIRCLES ---------------- */
  function initCircles() {
    $$('.hs-circles__wrap').forEach(function (w) {
      if (w.dataset.hsReady) return; w.dataset.hsReady = '1';
      var t = $('.hs-circles__track', w);
      function chk() { w.classList.toggle('overflowing', t.scrollWidth > t.clientWidth + 4); }
      chk(); window.addEventListener('resize', chk);
      $$('.hs-arrow', w).forEach(function (b) {
        b.addEventListener('click', function () { t.scrollBy({ left: (b.classList.contains('prev') ? -1 : 1) * t.clientWidth * 0.8, behavior: 'smooth' }); });
      });
    });
  }

  /* ---------------- REELS ---------------- */
  var RM = null, rmList = [], rmIdx = 0, rmMuted = false;
  function buildRM() {
    RM = document.createElement('div');
    RM.className = 'hs-rm';
    RM.setAttribute('role', 'dialog');
    RM.innerHTML = '<div class="hs-rm__stage"><div class="hs-rm__frame"></div></div>' +
      '<div class="hs-rm__progress"><i></i></div>' +
      '<button class="hs-rm__mute" aria-label="Sound"></button><button class="hs-rm__close" aria-label="Close">&times;</button>' +
      '<div class="hs-rm__nav"><button class="up" aria-label="Previous">&#8593;</button><button class="down" aria-label="Next">&#8595;</button></div>' +
      '<div class="hs-rm__card"></div>';
    document.body.appendChild(RM);
    $('.hs-rm__close', RM).addEventListener('click', closeRM);
    $('.hs-rm__nav .up', RM).addEventListener('click', function () { goRM(-1); });
    $('.hs-rm__nav .down', RM).addEventListener('click', function () { goRM(1); });
    $('.hs-rm__mute', RM).addEventListener('click', function () {
      rmMuted = !rmMuted; var v = $('video', RM); if (v) v.muted = rmMuted; setMuteIcon();
    });
    var sy = 0;
    RM.addEventListener('touchstart', function (e) { sy = e.touches[0].clientY; }, { passive: true });
    RM.addEventListener('touchend', function (e) {
      if (e.target.closest('.hs-rm__card')) return;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dy) > 60) goRM(dy < 0 ? 1 : -1);
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!RM.classList.contains('open')) return;
      if (e.key === 'Escape') closeRM();
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') goRM(1);
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') goRM(-1);
    });
    $('.hs-rm__stage', RM).addEventListener('click', function () {
      var v = $('video', RM); if (!v) return; if (v.paused) v.play(); else v.pause();
    });
  }
  function setMuteIcon() { $('.hs-rm__mute', RM).innerHTML = rmMuted ? ICON.mute : ICON.sound; }
  function reelData(card) {
    var s = $('.hs-reel-data', card);
    try { return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; }
  }
  function renderRM() {
    var card = rmList[rmIdx], frame = $('.hs-rm__frame', RM), bar = $('.hs-rm__progress i', RM);
    frame.innerHTML = ''; bar.style.width = '0';
    var cv = $('video', card), poster = $('.hs-reel__poster', card);
    if (cv) {
      var v = document.createElement('video');
      v.setAttribute('playsinline', ''); v.playsInline = true; v.loop = true; v.muted = rmMuted; v.preload = 'auto';
      if (cv.getAttribute('poster')) v.poster = cv.getAttribute('poster');
      $$('source', cv).forEach(function (s) { var n = document.createElement('source'); n.src = s.src; if (s.type) n.type = s.type; v.appendChild(n); });
      if (!v.children.length && cv.currentSrc) v.src = cv.currentSrc;
      frame.appendChild(v);
      v.addEventListener('timeupdate', function () { if (v.duration) bar.style.width = (v.currentTime / v.duration * 100) + '%'; });
      var p = v.play();
      if (p && p.catch) p.catch(function () { rmMuted = true; v.muted = true; setMuteIcon(); v.play(); });
      $('.hs-rm__mute', RM).style.display = '';
    } else {
      if (poster) { var im = document.createElement('img'); im.src = poster.currentSrc || poster.src; im.alt = ''; im.className = 'kb'; frame.appendChild(im); }
      $('.hs-rm__mute', RM).style.display = 'none';
    }
    setMuteIcon();
    var d = reelData(card), c = $('.hs-rm__card', RM);
    if (d) {
      var canAdd = d.available && !d.multi && d.variant;
      c.style.display = '';
      c.innerHTML = (d.image ? '<img src="' + d.image + '" alt="">' : '') +
        '<div class="hs-rm__info"><p class="hs-rm__t"></p><p class="hs-rm__p"></p></div>' +
        '<div class="hs-rm__btns">' + (canAdd ? '<button class="hs-rm__btn hs-rm__add" type="button">Add to Bag</button>' : '') +
        '<a class="hs-rm__btn ' + (canAdd ? 'alt' : '') + '" href="' + d.url + '">' + (d.multi ? 'Select Size' : 'View Piece') + '</a></div>';
      $('.hs-rm__t', c).textContent = d.title; $('.hs-rm__p', c).textContent = d.price;
      var add = $('.hs-rm__add', c);
      if (add) add.addEventListener('click', function () {
        add.textContent = 'Adding…';
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: d.variant, quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function () { add.textContent = 'Added ✓'; document.dispatchEvent(new CustomEvent('cart:refresh')); })
          .catch(function () { window.location.href = d.url; });
      });
    } else { c.style.display = 'none'; }
  }
  function openRM(list, i) {
    if (!RM) buildRM();
    rmList = list; rmIdx = i; RM.classList.add('open'); lockBody(true);
    $$('.hs-reel video').forEach(function (v) { v.pause(); });
    renderRM();
  }
  function goRM(d) { rmIdx = (rmIdx + d + rmList.length) % rmList.length; renderRM(); }
  function closeRM() {
    var v = $('video', RM); if (v) { v.pause(); v.removeAttribute('src'); }
    $('.hs-rm__frame', RM).innerHTML = '';
    RM.classList.remove('open'); lockBody(false);
    observeReels();
  }
  var io = null;
  function observeReels() {
    if (!('IntersectionObserver' in window)) return;
    if (!io) {
      io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          var v = $('video', en.target); if (!v) return;
          var auto = en.target.closest('[data-hs-reels]').dataset.autoplay === 'true';
          if (en.isIntersecting && en.intersectionRatio >= 0.6 && auto && !SAVE && !(RM && RM.classList.contains('open'))) {
            if (v.preload === 'none') v.preload = 'metadata';
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          } else { v.pause(); }
        });
      }, { threshold: [0, 0.6] });
    }
    $$('.hs-reel').forEach(function (c) { io.unobserve(c); io.observe(c); });
  }
  function initReels() {
    $$('[data-hs-reels]').forEach(function (sec) {
      if (sec.dataset.hsReady) return; sec.dataset.hsReady = '1';
      var cards = $$('.hs-reel', sec);
      cards.forEach(function (card, i) {
        var v = $('video', card); if (v) { v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; }
        function open(e) { if (e.target.closest('.hs-reel__prod')) return; e.preventDefault(); openRM(cards, i); }
        card.addEventListener('click', open);
        card.addEventListener('keydown', function (e) { if (e.key === 'Enter') open(e); });
      });
    });
    observeReels();
  }

  /* ---------------- STICKY ADD TO BAG (mobile) ---------------- */
  function initSticky() {
    var bar = $('.hs-satc'); if (!bar || bar.dataset.hsReady) return; bar.dataset.hsReady = '1';
    var form = $('main form[action*="/cart/add"]');
    var btn = form ? (form.querySelector('[type="submit"]') || form.querySelector('[name="add"]')) : null;
    if (!btn) btn = $('main .btn-add-to-cart, main .product-form__submit');
    var anchor = btn || form; if (!anchor) { bar.remove(); return; }
    var picker = $('main variant-picker, main .variant-picker, main .tf-product-info-variant-picker, main [class*="variant-picker"]');
    var needsChoice = bar.dataset.multi === 'true' && !!picker, chosen = false;
    var b = $('.hs-satc__b', bar);
    if (needsChoice) b.textContent = 'Select Size';
    if (picker) picker.addEventListener('click', function (e) {
      if (e.target.closest('input,label,button,a,[data-value],.variant-btn,.size-btn')) { chosen = true; if (bar.dataset.available === 'true') b.textContent = 'Add to Bag'; }
    });
    b.addEventListener('click', function () {
      if (needsChoice && !chosen) {
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (picker.animate) picker.animate([{ outline: '2px solid #b08d4a', outlineOffset: '6px' }, { outline: '2px solid transparent', outlineOffset: '6px' }], { duration: 1600 });
        return;
      }
      if (btn) btn.click(); else anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        var en = ents[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('show', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('hs-satc-on', show);
      }).observe(anchor);
    }
  }

  function boot() { try { initGallery(); } catch (e) { console.warn('hs gallery', e); } initCircles(); initReels(); initSticky(); }
  if (document.readyState === 'complete') boot(); else window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', function () { initCircles(); initReels(); });
})();
